// src/services/bibleApi.js


// Map of book names to 3-letter codes required by HelloAO API
const BOOK_CODES = {
  'Genesis': 'GEN', 'Exodus': 'EXO', 'Leviticus': 'LEV', 'Numbers': 'NUM', 'Deuteronomy': 'DEU',
  'Joshua': 'JOS', 'Judges': 'JDG', 'Ruth': 'RUT', '1 Samuel': '1SA', '2 Samuel': '2SA',
  '1 Kings': '1KI', '2 Kings': '2KI', '1 Chronicles': '1CH', '2 Chronicles': '2CH',
  'Ezra': 'EZR', 'Nehemiah': 'NEH', 'Esther': 'EST', 'Job': 'JOB', 'Psalms': 'PSA',
  'Proverbs': 'PRO', 'Ecclesiastes': 'ECC', 'Song of Solomon': 'SNG', 'Isaiah': 'ISA',
  'Jeremiah': 'JER', 'Lamentations': 'LAM', 'Ezekiel': 'EZK', 'Daniel': 'DAN',
  'Hosea': 'HOS', 'Joel': 'JOL', 'Amos': 'AMO', 'Obadiah': 'OBA', 'Jonah': 'JON',
  'Micah': 'MIC', 'Nahum': 'NAM', 'Habakkuk': 'HAB', 'Zephaniah': 'ZEP', 'Haggai': 'HAG',
  'Zechariah': 'ZEC', 'Malachi': 'MAL', 'Matthew': 'MAT', 'Mark': 'MRK', 'Luke': 'LUK',
  'John': 'JHN', 'Acts': 'ACT', 'Romans': 'ROM', '1 Corinthians': '1CO', '2 Corinthians': '2CO',
  'Galatians': 'GAL', 'Ephesians': 'EPH', 'Philippians': 'PHP', 'Colossians': 'COL',
  '1 Thessalonians': '1TH', '2 Thessalonians': '2TH', '1 Timothy': '1TI', '2 Timothy': '2TI',
  'Titus': 'TIT', 'Philemon': 'PHM', 'Hebrews': 'HEB', 'James': 'JAS', '1 Peter': '1PE',
  '2 Peter': '2PE', '1 John': '1JN', '2 John': '2JN', '3 John': '3JN', 'Jude': 'JUD', 'Revelation': 'REV'
};

// Fetch a Bible chapter from HelloAO API with localStorage caching and error handling
export async function fetchBibleChapter(book, chapter, translation = 'BSB') {
  const code = BOOK_CODES[book];
  if (!code) return [];
  const cacheKey = `bible_${translation}_${code}_${chapter}`;
  // Try cache first
  const cached = localStorage.getItem(cacheKey);
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch (e) {
      // ignore parse error, continue to fetch
    }
  }
  // Use translation code as provided (case-sensitive)
  const url = `https://bible.helloao.org/api/${translation}/${code}/${chapter}.json`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error('API error');
    const data = await res.json();
    // API returns { chapter: { content: [...] } }
    if (data && data.chapter && Array.isArray(data.chapter.content)) {
      // Extract only verse objects
      const verses = data.chapter.content
        .filter(item => item.type === 'verse')
        .map(item => ({
          verse: item.number,
          text: Array.isArray(item.content)
            ? item.content.map(c => (typeof c === 'string' ? c : (c.text || '')).trim()).join(' ').replace(/\s+/g, ' ')
            : ''
        }));
      localStorage.setItem(cacheKey, JSON.stringify(verses));
      return verses;
    }
    throw new Error('Invalid API response');
  } catch (err) {
    // Fallback: return empty array or cached data if available
    if (cached) {
      try {
        return JSON.parse(cached);
      } catch (e) {}
    }
    return [];
  }
}
